import { compose, equals, prop } from 'ramda'
import React, { useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SubItem } from '../../../../../components/structure/SubItems'
import { useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import EmptyDroppablePanel from '../../../../../components/dnd/EmptyDroppablePanel'
import QuestionPanel from './QuestionPanel'
import dndTypes from '../_constants/dndTypes'

const useFilteredQuestions = (questions, displayConditions) => {
  return useMemo(
    () =>
      !!displayConditions?.length //
        ? questions.filter(compose(equals(displayConditions), prop('displayConditions')))
        : questions,
    [questions, displayConditions]
  )
}

const QuestionsList = ({ questions, parentReference, isSubItems, displayConditions }) => {
  const { t } = useTranslation('editChecklist')
  const { addQuestionToParent, moveQuestionToParent } = useChecklistFormActions()

  const filteredQuestions = useFilteredQuestions(questions, displayConditions)
  const hasQuestions = filteredQuestions.length > 0

  const onDrop = useCallback(
    item => {
      const finalItem = { ...item, displayConditions }
      if (item.reference) {
        moveQuestionToParent(item.reference, parentReference, displayConditions)
      } else {
        addQuestionToParent(parentReference, finalItem)
      }
    },
    [parentReference, displayConditions, addQuestionToParent, moveQuestionToParent]
  )

  return (
    <div>
      {filteredQuestions.map((item, questionIndex) => (
        <QuestionPanel
          key={item.reference}
          question={item}
          index={questionIndex}
          isSubItem={isSubItems}
          displayConditions={displayConditions}
        />
      ))}
      {!hasQuestions && (
        <SubItem disabled={!isSubItems}>
          <EmptyDroppablePanel type={dndTypes.QUESTION} onDrop={onDrop} label={t('dragQuestionsHere')} />
        </SubItem>
      )}
    </div>
  )
}

export default QuestionsList
